import { Mapping } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isMapping } from 'src/containers/ProjectDiagram/utils/data';
import { doMappingUpdated } from 'src/containers/ProjectDiagram/utils/mapping/doMappingUpdated';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

/** removes an attribute as a target for a `field` on Mapping */
export const removeMappingField =
  ({
    attributeIri,
    fieldId,
    key,
  }: {
    attributeIri: string;
    fieldId: string;
    key: string;
  }) =>
  (model: Model) => {
    const mapping = model.linkDataArray.find(
      (linkData): linkData is Mapping =>
        isMapping(linkData) && linkData.key === key
    );
    if (!mapping) {
      return;
    }

    const field = mapping.fields[fieldId];

    let isRemoved = false;
    const targets = field.targets.filter((target) => {
      if (target === attributeIri && !isRemoved) {
        isRemoved = true;
        return false;
      }
      return true;
    });

    setDataProperty<Mapping>(model)(mapping, 'fields', {
      ...mapping.fields,
      [fieldId]: { ...field, targets },
    });
    doMappingUpdated(mapping)(model);
  };
